import React, { useRef } from "react";
import { useMount } from "react-use";

import { useIncode } from "./IncodeContext";

export const TutorialFrontId = () => {
  const containerRef = useRef(null);
  const { incode, token, navigateTo, track } = useIncode();

  useMount(() => {
    track("tutorial_front_viewed");
    incode.renderFrontTutorial(containerRef.current, {
      token: { token },
      onSuccess: () => navigateTo("front"),
      noWait: true,
    });
  });

  return <div id="incode-tutorial-front" ref={containerRef}></div>;
};
